export default "__VITE_ASSET__DN32T8zE__"